import Term from "./Term";
import { cn } from "@/lib/utils";
import type {
  ProgramNewsDeliveryClass,
  ProgramNewsUpdateCounts,
} from "@/services/adminProgramNews";

interface EventClassTabsProps {
  counts: Partial<ProgramNewsUpdateCounts>;
  active: ProgramNewsDeliveryClass;
  onChange: (deliveryClass: ProgramNewsDeliveryClass) => void;
}

const CLASSES: Array<{ key: ProgramNewsDeliveryClass; label: string }> = [
  { key: "alert", label: "Alert" },
  { key: "digest", label: "Digest" },
  { key: "ignore", label: "Ignore" },
];

const EventClassTabs = ({ counts, active, onChange }: EventClassTabsProps) => {
  return (
    <div
      className="inline-flex items-center gap-1 rounded-md bg-muted p-1"
      role="group"
      aria-label="Delivery class"
    >
      {CLASSES.map(({ key, label }) => {
        const isActive = active === key;
        const count = counts[key];
        return (
          <button
            key={key}
            type="button"
            aria-pressed={isActive}
            onClick={() => onChange(key)}
            className={cn(
              "rounded-sm px-3 py-1.5 text-sm font-medium transition-colors",
              isActive
                ? "bg-background text-foreground shadow-sm"
                : "text-muted-foreground hover:text-foreground"
            )}
          >
            <Term term={key}>{label}</Term>{" "}
            {typeof count === "number" ? (
              <span className="ml-1 rounded-full bg-muted-foreground/10 px-1.5 text-xs">
                {count}
              </span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
};

export default EventClassTabs;
